<template>
  <el-dialog :title="title" :visible.sync="visible" width="70%" :before-close="handleClose" center>
    <el-form ref="form" :model="form" label-width="auto">
      <el-form-item label="课程" size="small" class="mb0">
        <el-select v-model="form.id" placeholder="请选择课程" filterable clearable>
          <el-option :label="item.code+'-'+item.name" :value="item.id" v-for="(item, index) in courseList" :key="index"></el-option>
        </el-select>
        <span class="form-btn">
          <el-button type="primary" @click="handleAdd()">添加</el-button>
        </span>
      </el-form-item>
    </el-form>
    <div>
      <el-table :data="list" border style="width: 100%"
        :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="课程代码" align="center"></el-table-column>
        <el-table-column prop="name" label="课程名称" align="center"></el-table-column>
        <el-table-column prop="score" label="学分" align="center"></el-table-column>
        <!-- <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
            </template>
          </el-table-column> -->
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleClose">取消</el-button>
      <el-button size="mini" type="primary" @click="handleSubmit">提交报名</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      default: "综合评价选课报名"
    }
  },
  data () {
    return {
      visible: false,
      courseList: [],
      form: {
        examConfigId: '',
        id: ''
      },
      list: [],
    };
  },
  methods: {
    async open (examConfigId) {
      this.visible = true;
      this.list = []
      this.form.id = ''
      if (!examConfigId) {
        this.form.examConfigId = ''
        return
      }
      this.getCourseList(examConfigId)
    },
    handleClose () {
      this.visible = false;
    },
    handleSubmit () {
      if (!this.list.length) {
        this.$message.error('请选择课程')
        return
      }
      const params = {
        examConfigId: this.form.examConfigId,
        courseIds: this.list.map(item => item.id)
      }
      this.$http.post('/student/pc/chooseCourse/getCourseList', params).then((res) => {
        this.$message({
          showClose: true,
          message: "提交报名成功",
          type: "success",
        });
        this.$emit("refresh");
        this.visible = false
      })
    },
    async getCourseList (examConfigId) {
      this.form.examConfigId = examConfigId
      await this.$http.get('/student/pc/chooseCourse/getCourseList', { examConfigId }).then((res) => {
        this.courseList = res
      })
    },

    handleAdd () {
      let course = this.courseList.find(item => item.id == this.form.id)
      if (!course) {
        return
      }
      this.list.push(course)
      this.form.id = ''
      this.courseList = this.courseList.filter(item => item.id != course.id)
    },
  },
};
</script>

<style lang="scss" scoped>
.form-btn {
  margin-left: 20px;
}
</style>
